import { render, staticRenderFns } from "./KeywordCriteria.vue?vue&type=template&id=2b553d4f&scoped=true&"
import script from "./KeywordCriteria.vue?vue&type=script&lang=ts&"
export * from "./KeywordCriteria.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./KeywordCriteria.vue?vue&type=style&index=0&id=2b553d4f&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2b553d4f",
  null
  ,true
)

export default component.exports